module.exports = __webpack_public_path__ + "assets/logo_footer_old.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_footer_old.png
 ** module id = 222
 ** module chunks = 1
 **/